export const META_KEY = 'entity';

export class DataModelInfo {
   // entityName: string
}

export function DataModel(info: DataModelInfo) {
   return Reflect.metadata(META_KEY, info);
};